import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useFormikContext } from "formik";
import { useTranslation } from "gatsby-plugin-react-i18next";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { GtmManagerContext } from "../../shared/context/gtm-manager";
import { setFile } from "../../store/policyFinderSlice";
import { bytesToSize } from "../utils/formatter";
import Button from "./button";
var UploaderStyleContainer = styled.i.withConfig({ displayName: "uploader__UploaderStyleContainer", componentId: "sc-6jb0v6-0" })(["font-size:64px;", ""], { "--tw-text-opacity": "1", "color": "rgba(49, 116, 204, var(--tw-text-opacity))" });
var uploader = function uploader(props) {
    var _formik$values$props$, _props$display, _formik$errors$props$, _formik$touched$props, _formik$isSubmitting, _PolicyFinderState$ap, _props$formatError, _props$sizeError;
    var formik = useFormikContext();
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var dispatch = useDispatch();
    var PolicyFinderState = useSelector(function (state) { return state.policyFinder; });
    var defaultProps = { label: i18n.exists(props.name.toUpperCase() + ".LABEL") ? t(props.name.toUpperCase() + ".LABEL") : props.name, value: (_formik$values$props$ = formik === null || formik === void 0 ? void 0 : formik.values[props.name]) !== null && _formik$values$props$ !== void 0 ? _formik$values$props$ : null, display: (_props$display = props.display) !== null && _props$display !== void 0 ? _props$display : "reupload", error: (_formik$errors$props$ = formik === null || formik === void 0 ? void 0 : formik.errors[props.name]) !== null && _formik$errors$props$ !== void 0 ? _formik$errors$props$ : "", touched: (_formik$touched$props = formik === null || formik === void 0 ? void 0 : formik.touched[props.name]) !== null && _formik$touched$props !== void 0 ? _formik$touched$props : false, isSubmitting: (_formik$isSubmitting = formik === null || formik === void 0 ? void 0 : formik.isSubmitting) !== null && _formik$isSubmitting !== void 0 ? _formik$isSubmitting : false, color: "blue", isProgressShow: true };
    props = Object.assign({}, defaultProps, props);
    var _useState = useState(props.display), display = _useState[0], setDisplay = _useState[1]; //start ,upload ,error, reupload
    var _useState2 = useState(""), fileSize = _useState2[0], setFileSize = _useState2[1];
    var _useState3 = useState(props.isPolicyFinder ? (_PolicyFinderState$ap = PolicyFinderState.application.files) === null || _PolicyFinderState$ap === void 0 ? void 0 : _PolicyFinderState$ap.name : ""), fileName = _useState3[0], setFileName = _useState3[1];
    var _useState4 = useState(false), isFormatFail = _useState4[0], setIsFormatFail = _useState4[1];
    var _useState5 = useState(false), isSizeFail = _useState5[0], setIsSizeFail = _useState5[1];
    var _useState6 = useState(false), hasError = _useState6[0], setHasError = _useState6[1];
    var fileRef = React.useRef(null);
    var _useState7 = useState("started"), timmerStatus = _useState7[0], setTimmerStatus = _useState7[1];
    var _useState8 = useState(0), secondsRemaining = _useState8[0], setSecondsRemaining = _useState8[1];
    var gtm = React.useContext(GtmManagerContext);
    useEffect(function () { if (PolicyFinderState.application.files !== null) {
        setSecondsRemaining(100);
        setTimmerStatus("stopped");
        setDisplay("done");
    } });
    var selectFile = function selectFile() { fileRef.current.click(); setSecondsRemaining(0); };
    var updateFileName = function updateFileName(fileName) { var _Object$assign; setFileName(fileName); formik.setValues(Object.assign({}, formik.values, (_Object$assign = {}, _Object$assign[props.name] = fileName, _Object$assign))); };
    var pushGtm = function pushGtm(errorInfo) {
        var _props;
        if ((_props = props) !== null && _props !== void 0 && _props.gtmErrorEvent) {
            var _props2; // eslint-disable-next-line prefer-const
            var data = (_props2 = props) === null || _props2 === void 0 ? void 0 : _props2.gtmErrorEvent;
            data["eventDetails.label"] = errorInfo;
            data.errorMessage = errorInfo;
            gtm.push(data);
        }
    };
    useEffect(function () {
        if (isFormatFail || isSizeFail) {
            var text = "";
            if (isFormatFail) {
                text = "The file format/size does not meet the upload requirements. Please upload again.";
            }
            if (isSizeFail) {
                text = "The file size should not exceed 5MB.";
            }
            pushGtm(text);
        }
    }, [isFormatFail, isSizeFail]);
    var checkFile = /*#__PURE__*/ function () { var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(file, extenstion) { var isFail, target, _props$onChange, _props3; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
        switch (_context.prev = _context.next) {
            case 0:
                isFail = false;
                if (!(file == "")) {
                    _context.next = 10;
                    break;
                }
                props = Object.assign({}, defaultProps, props);
                setHasError(false);
                setIsFormatFail(false);
                setIsSizeFail(false);
                setFileSize("");
                setDisplay(props.display);
                updateFileName("");
                return _context.abrupt("return");
            case 10:
                target = file.target.files[0];
                updateFileName(target.name);
                setFileSize(bytesToSize(target.size));
                setDisplay("start");
                if (target.size > props.maxFileSize) {
                    setIsSizeFail(true);
                    setIsFormatFail(false);
                    isFail = true;
                }
                if (!extenstion.test(target.name)) {
                    setIsFormatFail(true);
                    setIsSizeFail(false);
                    isFail = true;
                }
                if (!isFail) {
                    _context.next = 21;
                    break;
                }
                setDisplay("error");
                setHasError(true);
                _context.next = 31;
                break;
            case 21:
                if (!props.isProgressShow) {
                    setSecondsRemaining(100);
                    setTimmerStatus("stopped");
                    setDisplay("done");
                }
                else {
                    setSecondsRemaining(0);
                    setTimmerStatus("started");
                    setHasError(false);
                }
                _context.prev = 22;
                _context.next = 25;
                return (_props$onChange = (_props3 = props).onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(_props3, target);
            case 25:
                _context.next = 31;
                break;
            case 27:
                _context.prev = 27;
                _context.t0 = _context["catch"](22);
                setDisplay("error");
                setHasError(true);
            case 31:
            case "end": return _context.stop();
        }
    } }, _callee, null, [[22, 27]]); })); return function checkFile(_x, _x2) { return _ref.apply(this, arguments); }; }();
    var useInterval = function useInterval(callback, delay) {
        var savedCallback = React.useRef(); // Remember the latest callback.
        useEffect(function () { savedCallback.current = callback; }, [callback]); // Set up the interval.
        useEffect(function () { function tick() { savedCallback.current(); } if (delay !== null) {
            var id = setInterval(tick, delay);
            return function () { return clearInterval(id); };
        } }, [delay]);
    };
    useInterval(function () { if (secondsRemaining < 99) {
        setSecondsRemaining(secondsRemaining + 1);
    }
    else {
        setTimmerStatus("stopped");
    } }, timmerStatus === "started" ? 70 : null // passing null stops the interval
    );
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("input", { ref: fileRef, type: "file", name: props.name, className: "hidden", onClick: function onClick(e) { fileRef.current.value = ""; }, onChange: function onChange(e) { checkFile(e, props.fileType); } }), display == "reupload" && /*#__PURE__*/ React.createElement(Button, { onClick: function onClick() { return selectFile(); }, text: props.label, size: "lg", color: props.color }) // <div className="btn-upload-cta border border-blue-70 text-blue-70 p-10 cursor-pointer">
    //   <div className="w-full relative " onClick={() => selectFile()}>
    //     <div className="text-blue-70 w-full text-left">上傳身份證 AA</div>
    //     <div className="absolute right-0 top-0">
    //       <i className="i-upload text-xl"></i>
    //     </div>
    //   </div>
    // </div>
    , (display == "start" || display == "upload" || display == "error" || display == "done") && /*#__PURE__*/ React.createElement("div", { className: "proof-upload flex p-3 w-full" }, /*#__PURE__*/ React.createElement("div", { className: "w-14 h-14 -mt-1" }, /*#__PURE__*/ React.createElement(UploaderStyleContainer, { className: "i-upload-file" })), /*#__PURE__*/ React.createElement("div", { className: "flex-1 px-3" }, /*#__PURE__*/ React.createElement("div", { className: "flex w-full justify-between" }, /*#__PURE__*/ React.createElement("p", { className: "h6 pr-5 break-all" }, fileName), /*#__PURE__*/ React.createElement("i", { className: "i-cross text-mh5 text-gray-400", onClick: function onClick() { var _props4; if ((_props4 = props) !== null && _props4 !== void 0 && _props4.gtmLinkEvent && hasError) {
            var _props5;
            gtm.push((_props5 = props) === null || _props5 === void 0 ? void 0 : _props5.gtmLinkEvent);
        } dispatch(setFile(null)); checkFile("", props.fileType); } })), /*#__PURE__*/ React.createElement("div", { className: "bg-gray-400 rounded-full h-1 my-1" }, hasError ? /*#__PURE__*/ React.createElement("div", { className: "bg-red-60 w-full h-full" }) : /*#__PURE__*/ React.createElement("div", { className: "bg-blue-60 w-full h-full " + (display != "done" ? "animate-slide-in-left-8s" : "") })), /*#__PURE__*/ React.createElement("div", { className: "flex  relative w-100 " + (hasError ? "text-red-60" : "") }, hasError ? /*#__PURE__*/ React.createElement("p", { className: "text-xs pr-12 mr-2" }, isFormatFail ? /*#__PURE__*/ React.createElement("span", null, (_props$formatError = props.formatError) !== null && _props$formatError !== void 0 ? _props$formatError : "") : "", isSizeFail ? /*#__PURE__*/ React.createElement("span", null, (_props$sizeError = props.sizeError) !== null && _props$sizeError !== void 0 ? _props$sizeError : "") : "") : /*#__PURE__*/ React.createElement("p", { className: "text-sm" }, t("UPLOADER.COMPLETED"), " ", /*#__PURE__*/ React.createElement("span", { className: "nbr" }, secondsRemaining), "%"), /*#__PURE__*/ React.createElement("p", { className: "text-xs text-black-60 absolute right-0 top-0" }, fileSize)))), props.error && (props.isSubmitting || props.touched) ? /*#__PURE__*/ React.createElement("p", { className: "text-xs pt-2 text-red-60 " + (props.isPolicyFinder ? "pl-4" : "") + "  }" }, props.error) : "");
};
export default uploader;
